import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'

import { getOrderMetrics } from '../investorOverviewEndpoints'
import { investorOverviewQueryKeys } from '../investorOverviewQueryKeys'

export function useOrderMetricsQuery(investorId?: MaybeRefOrGetter<string | undefined>) {
  const resolvedInvestorId = toValue(investorId)
  return useQuery({
    queryKey: investorOverviewQueryKeys.metrics(resolvedInvestorId),
    queryFn: () => getOrderMetrics(resolvedInvestorId),
  })
}
